import { useEffect, useState } from 'react';

const useCapsLockDetection = () => {
    const [showCapsLockWarning, setShowCapsLockWarning] = useState(false);

    useEffect(() => {
        const detectCapLock = event => {
            let capsLockOn = false;
            if (typeof event.getModifierState === 'function') {
                capsLockOn = event.getModifierState('CapsLock');
            }
            setShowCapsLockWarning(capsLockOn);
        };

        window.addEventListener('keydown', detectCapLock);
        window.addEventListener('keyup', detectCapLock);

        return () => {
            window.removeEventListener('keydown', detectCapLock);
            window.removeEventListener('keyup', detectCapLock);
        };
    }, []);

    return { showCapsLockWarning };
};

export default useCapsLockDetection;
